module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_3016.9612756c.png";